<template>
<li class="nav-header">
  <div class="profile-element" v-if="getCurrentUserInfo">
    <div class="flex-box fl-between">
      <span @click="onClickSidebarProfile" class="info-userimg">
        <img v-if="getCurrentUserInfo.userIcon" class="img-circle" :src="getCurrentUserInfo.userIcon"  :alt='getCurrentUserInfo.userName'>
        <img v-else class="img-circle" :src="'static/img/noImage.png'"  :alt='getCurrentUserInfo.userName'>
      </span>
      <div class="nav-status" v-bind:class="{ willysmImage: willysmEnabled}">
        <profile-drop-down v-bind:class="{ willysmImage: willysmEnabled}" v-on:set-feeling="updateFeeling" :feeling="getCurrentUserInfo.userFeeling"/>
      </div>
    </div>
      <router-link :to="{ name: 'Profile' }"><span class="block"> <strong class="font-bold">{{ getCurrentUserInfo.userName }}</strong></span></router-link>
      <!-- <span class="block user-comment"> {{ getCurrentUserInfo.userBio }}</span> -->
      <span v-html="getUserbio" v-linkified class="block user-comment"> </span>
  </div>
</li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProfileDropDown from '@/components/User/ProfileDropDown'
import linkify from 'vue-linkify'
import { willysm } from '@/main.js'
export default {
  components: {
    ProfileDropDown
  },
  data () {
    return {
      userInfo: [],
      willysmEnabled: willysm.enabled
    }
  },
  directives: {
    linkified: linkify
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('repository/', [
      'getEdittingProfileFlag'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    getUserbio () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userBio) {
        var valContainer = this.getCurrentUserInfo.userBio
        let stringArray = []
        let contentText = valContainer.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/`/g, '&#x60;')
        stringArray = contentText.split(/\r?\n/g)
        let resultContent = stringArray.join('<br>')
        return resultContent
        // return this.getCurrentUserInfo.userBio
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions('profiles/', {
      setFeeling: 'SET_FEELING'
    }),
    updateFeeling: function (value) {
      this.setFeeling(value)
    },
    onClickSidebarProfile () {
      let isShowSWAL = (
        this.$route.name.indexOf('Regist') > 0 ||
        (this.getEdittingProfileFlag && this.$route.name.indexOf('Profile') > -1) ||
        (this.$route.name.indexOf('OneRequest') > -1 && this.$route.name.indexOf('Rece') < 0 && this.$route.name.indexOf('Sent') < 0)
      )
      if (isShowSWAL) {
        const $t = this.$t
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          // text: $t('doDeleteStr'),
          text: $t('confirmInputDeleteStr'),
          showCancelButton: true,
          cancelButtonColor: '#f64846',
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 3000
        }).then((result) => {
          if (result.value) {
            // okが押下されたら
            // e.target.parentElement.classList.toggle('active')
            // this.setTimestamp()
            // this.currentTimestamp = new Date().getTime() / 1000
            // this.currentTimestamp = Math.round((new Date()).getTime() / 1000)
            // this.setCurrentTimestamp(this.currentTimestamp)
            this.$router.push({ name: 'Profile' })
          } else {
            // cancelが押下されたら
            console.log('false')
          }
        })
      } else {
        // const setTimestamp = this.setCurrentTimestamp()
        // this.setTimestamp()
        // this.currentTimestamp = new Date().getTime() / 1000
        // this.currentTimestamp = Math.round((new Date()).getTime() / 1000)
        // this.setCurrentTimestamp(this.currentTimestamp)
        this.$router.push({ name: 'Profile' })
      }
      // this.$router.push({ name: target })
    }
  }
}
</script>
<style scoped>
.flex-box {
  padding: 10px 0;
}
.willysmImage {
  left: 46px;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarProfile.vue